import React, { cloneElement } from 'react';
import {
  List,
  Show,
  Edit,
  Datagrid,
  TextField,
  ReferenceField,
  SimpleForm,
  SimpleShowLayout,
  ShowButton,
  EditButton,
  // BooleanInput,
  SelectInput,
  ReferenceInput,
  // BooleanField,
  CardActions,
  RefreshButton,
  translate,
  ReferenceManyField,
  SingleFieldList,
  FunctionField,
  ChipField,
  ImageField,
  Filter,
  TextInput,
  DeleteButton,
  ListButton,
  Toolbar,
  SaveButton,
  DisabledInput
} from 'react-admin';
// import { renderComponent } from 'recompose';
import { Title } from '../components/Title';

// import { PageTitle } from './common';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import UserIcon from '../assets/SVGicon';
import { Pagination } from 'react-admin';

require('moment/locale/es.js');
require('moment/locale/fr.js');

const paginationUser = 50;
const PostPagination = props => (
  <Pagination rowsPerPageOptions={[]} {...props} />
);

const styles = theme => ({
  hiddenOnMediumScreens: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  image: {
    width: 'auto',
    height: '100%',
    maxHeight: '3rem',
    objectFit: 'cover'
  }
});

const UsersListActions = ({
  resource,
  filters,
  showFilter,
  displayedFilters,
  filterValues
}) => (
  <CardActions>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}
    <RefreshButton />
  </CardActions>
);

const UsersFilter = props => {
  const { translate } = props;
  return (
    <Filter {...props}>
      <ReferenceInput
        sort={{ field: 'name', order: 'ASC' }}
        label={translate('resources.companies.name', 2)}
        source="companyId"
        reference="companies"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>

      <TextInput
        label={`${translate('resources.events.search')} ${translate(
          'resources.users.name',
          1
        ).toLowerCase()} `}
        // label="rechercher"
        source="searchQuery"
        alwaysOn
      />
    </Filter>
  );
};

const renderUserPhoto = ({ record, classes, ...rest }) => {
  return record && record.photoURL ? (
    <img
      src={record.photoURL}
      // srcSet={record.photoURL ? record.photoURL : default_user_photo}
      alt="Default"
      style={{
        marginTop: 7,
        width: 65,
        height: 65,
        borderRadius: 40
        //objectFit: 'contain'
      }}
    />
  ) : (
    UserIcon('60', { marginTop: 5 }, 'grey')
  );
};

const renderContributionsInList = ({ record }) => (
  <div record={record}>{record.missionIds ? record.missionIds.length : 0}</div>
);

const renderEventsInList = ({ record }) => (
  <div record={record}>{record.eventIds ? record.eventIds.length : 0}</div>
);

let UsersList = (props, record) => {
  const { translate, classes, options } = props;
  const { roleLevel } = options;
  return (
    <List
      // title={<PageTitle title={translate('resources.users.name', 2)} />}
      title={<Title />}
      perPage={paginationUser}
      //title={<PageTitle title={translate('resources.users.name', 2)} />}
      actions={<UsersListActions />}
      bulkActionButtons={false}
      sort={{ field: 'name', order: 'ASC' }}
      {...props}
      pagination={<PostPagination />}
      filters={<UsersFilter translate={translate} />}
      //pagination={null}
    >
      <Datagrid>
        <FunctionField
          render={record => renderUserPhoto({ record, classes })}
        />
        <TextField
          source="name"
          // sortable={false}
        />
        <ReferenceField
          label={translate('resources.companies.name', 1)}
          source="companyId"
          reference="companies"
          linkType="show"
          allowEmpty
          sortable={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          source="metadata.creationTime"
          label={translate('resources.users.registrationDate')}
          headerClassName={classes.hiddenOnMediumScreens}
          cellClassName={classes.hiddenOnMediumScreens}
          render={record => registrationDate({ record, translate })}
        />
        <FunctionField
          source="metadata.lastSignInTime"
          label={translate('resources.users.lastConnexion')}
          headerClassName={classes.hiddenOnMediumScreens}
          cellClassName={classes.hiddenOnMediumScreens}
          render={record => lastConnexion({ record, translate })}
        />
        <FunctionField
          headerClassName={classes.hiddenOnMediumScreens}
          cellClassName={classes.hiddenOnMediumScreens}
          source="missionIds"
          label={translate('resources.contributions.name', 2)}
          render={record => renderContributionsInList({ record })}
        />
        <FunctionField
          headerClassName={classes.hiddenOnMediumScreens}
          cellClassName={classes.hiddenOnMediumScreens}
          source="eventIds"
          label={translate('resources.events.title', 2)}
          render={record => renderEventsInList({ record })}
        />

        {/* <BooleanField source="isAdmin" /> */}
        <ShowButton />
        {roleLevel > 0 && (
          <EditButton
            headerClassName={classes.hiddenOnMediumScreens}
            cellClassName={classes.hiddenOnMediumScreens}
          />
        )}
      </Datagrid>
    </List>
  );
};

// let UserTitle = ({ record, translate }) => (
//   <span>
//     {`${translate('resources.users.name', 1)} : `}
//     {record ? `${record.name}` : ''}
//   </span>
// );

const renderEvents = ({ record, translate, ...rest }) => {
  return record && record.eventIds ? (
    <ReferenceManyField
      record={record}
      {...rest}
      basePath="/events"
      reference="users"
      target="eventIds"
    >
      <SingleFieldList linkType="show">
        <ChipField source="title" />
      </SingleFieldList>
    </ReferenceManyField>
  ) : (
    translate('resources.events.no_participation')
  );
};

const renderContributionsInShow = ({
  record,
  translate,
  resource,
  ...rest
}) => {
  return record && record.missionIds ? (
    <ReferenceManyField
      resource
      record={record}
      {...rest}
      basePath="/missions"
      reference="users"
      target="missionIds"
    >
      <SingleFieldList linkType="show">
        <ChipField source="title" />
      </SingleFieldList>
    </ReferenceManyField>
  ) : (
    translate('resources.events.no_participation')
  );
};

const registrationDate = ({ record, translate, ...rest }) => {
  if (record && record.metadata) {
    const { creationTime } = record.metadata;
    return (
      <div>
        <p>{moment(creationTime).format('L')}</p>
      </div>
    );
  }
  return translate('resources.users.no_data');
};

const lastConnexion = ({ record, translate, ...rest }) => {
  if (record && record.metadata) {
    const { lastSignInTime } = record.metadata;
    return (
      <div>
        <p>{moment(lastSignInTime).format('L')}</p>
      </div>
    );
  }
  return translate('resources.users.no_data');
};

const renderMetadata = ({ record, translate, ...rest }) => {
  if (record && record.metadata) {
    const { creationTime, lastSignInTime } = record.metadata;
    return (
      <div>
        <p>
          <em> {translate('resources.users.fields.creationTime')} :</em>
          {moment(creationTime).format('LLL')}
        </p>
        <p>
          <em>{translate('resources.users.fields.lastSignInTime')} : </em>
          {moment(lastSignInTime).format('LLL')}
        </p>
      </div>
    );
  }
  return null;
};

const renderPhoneField = ({ record, translate }) =>
  record.phoneNumber ? (
    record.phoneNumber
  ) : (
    <em> {translate('resources.users.fields.missing', 1)} </em>
  );

const renderMailField = ({ record, translate }) =>
  record.email ? (
    record.email
  ) : (
    <em> {translate('resources.users.fields.missing', 2)} </em>
  );

const UsersShowActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      {roleLevel > 0 && <EditButton basePath={basePath} record={data} />}
      <ListButton basePath={basePath} />
      <RefreshButton />
      {roleLevel > 1 &&
        data &&
        data.role &&
        data.role !== 'owner' && (
          <DeleteButton basePath={basePath} resource={resource} record={data} />
        )}
    </CardActions>
  );
};

// let renderShowRole = ({ record, translate }) => {
//   return `(${record.role === 'noAdmin' ? 'Not admin' : record.role})`;
// };

let UserShow = ({ translate, classes, options, ...rest }) => {
  const { roleLevel } = options;
  return (
    <Show
      // title={<UserTitle />}
      title={<Title />}
      actions={
        <UsersShowActions resource={rest.resource} roleLevel={roleLevel} />
      }
      {...rest}
    >
      <SimpleShowLayout>
        <FunctionField
          addLabel={false}
          render={record => renderMetadata({ record, translate })}
        />
        <TextField source="name" />
        {/* <FunctionField
          addLabel={false}
          render={record => renderShowRole({ record, translate })}
        /> */}
        <ImageField classes={classes} source="photoURL" label="Photo" />
        <FunctionField
          label={translate('resources.users.fields.email')}
          render={record => renderMailField({ record, translate })}
        />

        <FunctionField
          label={translate('resources.users.fields.phoneNumber')}
          render={record => renderPhoneField({ record, translate })}
        />
        <ReferenceField
          label={translate('resources.companies.name', 1)}
          source="companyId"
          reference="companies"
          linkType={false}
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          label={translate('resources.contributions.name', 2)}
          render={record => renderContributionsInShow({ record, translate })}
        />

        <FunctionField
          label={translate('resources.events.title', 2)}
          // addLabel={false}
          render={record => renderEvents({ record, translate })}
        />
      </SimpleShowLayout>
    </Show>
  );
};

const UsersEditActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      <ShowButton basePath={basePath} record={data} />
      <ListButton basePath={basePath} />
      <RefreshButton />
      {roleLevel > 1 &&
        data &&
        data.role &&
        data.role !== 'owner' && (
          <DeleteButton basePath={basePath} resource={resource} record={data} />
        )}
    </CardActions>
  );
};

// let renderRoleSelector = ({ translate, roleLevel }) => {
const RenderEditRole = ({ roleLevel, record }) => {
  let selectedUserRole = record.role;
  let selectedUserRoleId = record.role;

  switch (selectedUserRole) {
    case 'viewer':
      selectedUserRole = 'viewer';
      break;
    case 'editor':
      selectedUserRole = 'editor';
      break;
    case 'master':
      selectedUserRole = 'master';
      break;
    case 'owner':
      selectedUserRole = 'owner';
      break;
    default:
      selectedUserRole = 'not_admin';
      break;
  }

  switch (roleLevel) {
    case 3:
      return (
        <SelectInput
          source="role"
          choices={[
            {
              id: 'noAdmin',
              name: 'not_admin'
            },
            {
              id: 'viewer',
              name: 'viewer'
            },
            {
              id: 'editor',
              name: 'editor'
            },

            {
              id: 'master',
              name: 'master'
            },
            {
              id: 'owner',
              name: 'owner'
            }
          ]}
        />
      );
    case 2:
      return selectedUserRole === 'owner' ? (
        <SelectInput
          source="role"
          choices={[
            {
              id: selectedUserRoleId,
              name: selectedUserRole
            }
          ]}
        />
      ) : (
        <SelectInput
          source="role"
          choices={[
            {
              id: 'noAdmin',
              name: 'not_admin'
            },
            {
              id: 'viewer',
              name: 'viewer'
            },
            {
              id: 'editor',
              name: 'editor'
            },
            {
              id: 'master',
              name: 'master'
            }
          ]}
        />
      );
    case 1:
      return selectedUserRole === 'not_admin' ||
        selectedUserRole === 'master' ||
        selectedUserRole === 'owner' ? (
        <SelectInput
          source="role"
          choices={[
            {
              id: selectedUserRoleId,
              name: selectedUserRole
            }
          ]}
        />
      ) : (
        <SelectInput
          source="role"
          choices={[
            {
              id: 'viewer',
              name: 'viewer'
            },
            {
              id: 'editor',
              name: 'editor'
            }
          ]}
        />
      );
    default:
      return 'Role non reconnu';
  }
};

const UserEditToolbar = ({ record, ...rest }) => {
  return (
    <Toolbar {...rest}>
      <SaveButton label="ENREGISTRER" redirect="show" submitOnEnter={true} />
    </Toolbar>
  );
};

let UserEdit = props => {
  const { translate, classes, options, resource, ...rest } = props;
  const { roleLevel } = options;
  return (
    <Edit
      // title={<UserTitle />}
      title={<Title />}
      actions={<UsersEditActions resource={resource} roleLevel={roleLevel} />}
      resource={resource}
      {...rest}
    >
      <SimpleForm toolbar={<UserEditToolbar />}>
        <ImageField classes={classes} source="photoURL" label="Photo" />
        <DisabledInput source="name" />
        {/* {renderRoleSelector({translate, roleLevel})} */}
        {roleLevel > 2 && (
          <RenderEditRole translate={translate} roleLevel={roleLevel} />
        )}
        <ReferenceInput
          label={translate('resources.companies.name', 1)}
          source="companyId"
          reference="companies"
          allowEmpty
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

// UserTitle = translate(UserTitle);
UsersList = translate(UsersList);
UsersList = withStyles(styles)(UsersList);
UserShow = translate(UserShow);
UserEdit = translate(UserEdit);

export { UsersList, UserShow, UserEdit };



// WEBPACK FOOTER //
// ./src/components/Users.js